import * as fromRoot from 'src/app/store';


export interface State extends fromRoot.State.State {
    appstate: fromRoot.State.AppState;
    businessdetailsstate: BusinessDetailsState;
  }

export interface BusinessDetailsState {
    businessDetails: any;
    found: boolean;
    incorporationDate: string;
    legalName: string;
    isOrgBookServiceDown: boolean;
    orgBookDetails: any;
}

export const initialState: BusinessDetailsState = {
    businessDetails: { },
    found: null,
    incorporationDate: null,
    legalName: null,
    isOrgBookServiceDown: false,
    orgBookDetails: {}
};
